import { ApplicationRef, Injectable, NgZone } from "@angular/core";
import { PopupService, IBlockerPopup } from "@karma-games/angular-devkit/src/lib/modules/popup";
import { ApplicationErrors, ApplicationErrorType, DomainErrors, DomainErrorType } from "@karma-games/angular-devkit/src/lib/classes/errors";
import { ErrorPageService } from "../../error-page/error-page.service";

@Injectable()
export class HttpErrorHandlerService {
    constructor(private popup: PopupService,
                private appRef: ApplicationRef,
                private ngZone: NgZone,
                private errorPageService: ErrorPageService) {
    }

    handle(error: ApplicationErrorType | typeof DomainErrors): void {
        if (!this.appRef || !this.appRef.components.length) {
            return;
        }

        if (<ApplicationErrorType>error instanceof ApplicationErrors.ServerUnavailableError || <ApplicationErrorType>error instanceof ApplicationErrors.GenericError) {
            this.showAppReloadErrorPopup();
        } else if (<DomainErrorType>error instanceof DomainErrors.UnauthorizedError) {
            this.showAppReloadErrorPopup("UNAUTHORIZED_ERROR_RELOAD");
        } else if (<DomainErrorType>error instanceof DomainErrors.BannedError) {
            this.onBanned();
        } else {
            return;
        }
    }

    private showAppReloadErrorPopup(messageKey?: string): void {
        this.ngZone.run(() => {
            let popupData: IBlockerPopup = {
                message: { key: messageKey ?? "APP_ERROR_RELOAD" },
                button: {
                    text: { key: "RELOAD" },
                    action: () => {
                        window.location.reload();
                    }
                }
            };

            this.popup.blocker(popupData);
            this.popup.togglePopupDisabled(true);
        });
    }

    private onBanned(): void {
        this.errorPageService.showErrorPage({
            errorText: "ERROR_BANNED"
        });
    }
}
